import styled from "styled-components";
export const StyledSidebar = styled.aside`
  border-radius: 0px 18px 18px 0px;
  background: #0D2702;
  box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.3);
  position: fixed;
  inset: 0;
  width: ${({ isCollapsed }) => (isCollapsed ? "100px" : "250px")};
  padding: 40px 20px 40px 0;
  z-index: 10;
  display: flex;
  flex-direction: column;
  transition: all 0.5s ease;
  transform: none;

  @media (max-width: 991px) {
    width: 250px;
    transform: ${({ isCollapsed }) =>
      isCollapsed ? "translateX(-100%)" : "translateX(0%)"};
  }

  ::-webkit-scrollbar {
    width: 5px;
    height: 20px;
  }

  /* Track */
  ::-webkit-scrollbar-track {
    border-radius: 15px;
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: ${({ theme }) => theme?.light?.primary50};
    border-radius: 10px;
  }
  .toggle-icon {
    cursor: pointer;
    position: absolute;
    top: 23px;
    right: -40px;
    max-width: 40px;
    padding: 7px;
    border-radius: 10px;
    background: ${({ theme }) => theme?.light?.primary};

    @media (min-width: 992px) {
      top: 35px;
      right: -20px;
    }

    img {
      width: 20px;
      height: 20px;
      transform: ${({ isCollapsed }) =>
        isCollapsed ? "rotate(0deg)" : "rotate(180deg)"};
      transition: transform 0.3s ease;
    }
  }
  .add-menus {
    background: #7DF500;
    padding: 12px 10px;
    border-radius: 30px;
    text-align: center;
    margin-left: 15px;
    color: #242424;
    img {
      margin-top: -47px;
      margin-bottom: 10px;
    }
    button {
      margin-top: 10px;
      background: #0D2702;
      color: #fff;
    }
  }
`;
export const NavWrapper = styled.div`
  display: flex;
  flex-grow: 1;
  padding-left: 20px;
  margin-bottom: 50px;
  overflow: hidden;
  overflow-y: auto;
  ul {
    width: 100%;
    .foodie-logo-wrapper {
      max-width: 150px;
      margin: 0 auto 20px;
      display: flex;
      justify-content: center;
      /* justify-content: ${({ isCollapsed }) =>
        isCollapsed ? "" : "center"}; */
    }
    li.linkItems {
      position: relative;
      padding: 16px 15px;
      margin-bottom: 8px;
      font-size: 16px;
      line-height: 20px;
      font-weight: 400;
      border-radius: 20px;
      transition: 0.3s all ease-in-out;
      display: flex;
      gap: 10px;
      cursor: pointer;

      &::before {
        content: "";
        position: absolute;
        left: -25px;
        top: 7px;
        width: 10px;
        height: 0px;
        background-color: ${({ theme }) => theme?.light?.primary};
        border-radius: 58px;
        transition: 0.3s all ease-in-out;
      }
      &.active,
      &:hover {
        background: rgba(125, 245, 0, 0.15);
        img {
          cursor: pointer;
          filter: brightness(0) saturate(100%) invert(82%) sepia(80%)
            saturate(500%) hue-rotate(40deg) brightness(110%) contrast(110%);
        }
        &::before {
          height: 45px;
        }
        a {
          color: #7DF500;
        }
      }
      a {
        color: rgba(255, 255, 255, 0.75);
        display: block;
      }
    }
    .collapsed {
      width: 52px;
      height: 52px;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 5px !important;
      &::before {
        content: "";
        top: 1px !important;
      }
    }
    .subLinkItems {
      background: transparent;
      position: relative;
      &::before {
        content: "";
        position: absolute;
        left: -25px;
        top: 7px;
        width: 10px;
        height: 0px;
        background-color: ${({ theme }) => theme?.light?.primary};
        border-radius: 58px;
        transition: 0.3s all ease-in-out;
      }
      &.active,
      &:hover {
        &::before {
          height: 45px;
        }
      }
    }
  }
`;

export const UserLogout = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 15px;
  margin-left: 20px;
  .userProfile {
    width: 50px;
    height: 50px;
    border-radius: 50px;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(125, 245, 0, 0.2);
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
  .text {
    padding-top: 5px;
    color: rgba(255, 255, 255, 0.6);
    font-size: 14px;
    line-height: 18px;
    font-weight: 400;
    .designation {
      display: block;
      margin-bottom: 10px;
    }
    .name {
      display: block;
      margin-bottom: 5px;
      color: #fff;
      font-size: 16px;
      line-height: 20px;
      font-weight: 700;
      text-transform: capitalize;
    }
  }
`;
